import { render, staticRenderFns } from "./generic-input.vue?vue&type=template&id=4fc77002"
import script from "./generic-input.vue?vue&type=script&lang=js"
export * from "./generic-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports